import axios from "axios";
import { Api_Caller } from "../../utils/Api";


const BASE_URL = process.env.REACT_APP_API_ALL;

const getHeaders = (token) => ({
  headers: {
    Authorization: `Bearer ${token}`,
  },
});

// ======================
// Get Agent Listing
// ======================
export const getAgentListingApi = (token) => {
  return axios.get(
    `${BASE_URL}/${Api_Caller.agents}`,
    getHeaders(token)
  );
};

// ======================
// Create Agent
// ======================
export const createAgentApi = (formData, token) => {
  return axios.post(
    `${BASE_URL}/${Api_Caller.createAgent}`,
    formData,
    getHeaders(token)
  );
};

// ======================
// Change Agent Status
// ======================
export const changeAgentStatusApi = (mobile, token) => {
  return axios.post(
    `${BASE_URL}/${Api_Caller.agentStatus}?mobile=${mobile}`,
    {},
    getHeaders(token)
  );
};

// ======================
// Change Selfie Status
// ======================
export const changeSelfieStatusApi = (mobile, token) => {
  return axios.post(
    `${BASE_URL}/${Api_Caller.changeSelfieStatus}?mobile=${mobile}`,
    {},
    getHeaders(token)
  );
};


// ======================
// Change Selfie Status
// ======================
export const changeAllSelfieStatusApi = (status, token) => {
  return axios.post(
    `${BASE_URL}/${Api_Caller.changeSelfieStatusAll}?status=${status}`,
    {},
    getHeaders(token)
  );
};


// ======================
// Change Agent Password
// ======================

export const changePasswordApi = (formData) => {
  return axios.post(
    `${BASE_URL}/${Api_Caller.changePassword}`,
    formData
  );
};